
define('tpl!taoQtiItem/qtiCreator/tpl/modalFeedback/panel', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<h3 class=\"has-icon\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Modal Feedbacks", options) : helperMissing.call(depth0, "__", "Modal Feedbacks", options)))
    + "</h3>\n<span class=\"icon-help tooltipstered\" data-tooltip=\"~ .tooltip-content\" data-tooltip-theme=\"info\"></span>\n<span class=\"tooltip-content\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Modal feedback is shown to the candidate directly following response processing.", options) : helperMissing.call(depth0, "__", "Modal feedback is shown to the candidate directly following response processing.", options)))
    + "</span>\n<div class=\"feedbackRules\">\n    <p><i>"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "None defined yet.", options) : helperMissing.call(depth0, "__", "None defined yet.", options)))
    + "</i></p>\n</div>\n<a href=\"#\" class=\"adder feedbackRule-add\">"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "Add a modal feedback", options) : helperMissing.call(depth0, "__", "Add a modal feedback", options)))
    + "</a>";
  return buffer;
  });
});

